import { Hero } from "@/components/landing/Hero";
import { ScrollStory } from "@/components/landing/ScrollStory";
import { BeforeAfter } from "@/components/landing/BeforeAfter";
import { CinematicBreak } from "@/components/landing/CinematicBreak";
import { ServiceIndex } from "@/components/landing/ServiceIndex";
import { Process } from "@/components/landing/Process";
import { FinalCta } from "@/components/landing/FinalCta";
import { Manifesto } from "@/components/landing/Manifesto";
import { usePageMeta } from "@/hooks/use-page-meta";

export const HomePage = () => {
  usePageMeta("Tecnologia que move negócios", "Sistemas, CRMs, sites e automações com inteligência artificial desenvolvidos para a realidade da sua empresa.");

  return (
    <main>
      <Hero />
      <BeforeAfter />
      <CinematicBreak />
      <ScrollStory />
      <Manifesto />
      <ServiceIndex />
      <Process />
      <FinalCta />
    </main>
  );
};
